export default {
    getCentroDeCustos: (state)=> state.centroDeCustos,
    getCentroDeCustoSelecionado: (state)=>state.centroDeCustoSelecionado
}